// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2Wglu","label":"SetPasswdForm_label__3W1tR"};